import { PERSONEL_GROUP_FOLLOW_MEMBERS_LIMIT } from '../constants';

export const tooManyGroupMembers = (memberCount: number[]) =>
  memberCount.length > 0 &&
  memberCount.reduce((sum, num) => sum + num, 0) >
    PERSONEL_GROUP_FOLLOW_MEMBERS_LIMIT;
